import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { BaseConfirmationDialog, LoadingFeedback } from 'components'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'

const ChangeStatusCategoryDialog = ({ open, setOpen, category, onRefresh }) => {
  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()

  const isActive = category.active !== false
  const snackBarText = isActive ? 'inativada' : 'ativada'
  const actionText = isActive ? 'Inativar' : 'Ativar'
  const newStatus = !isActive

  const handleConfirmAction = async () => {
    setLoading(true)
    try {
      await service.dponet.complaintCategories.update(category.id, {
        complaintCategory: {
          active: newStatus,
        },
      })
      snackbar.open({
        message: `Categoria ${snackBarText} com sucesso!`,
        variant: 'success',
      })
      onRefresh()
      setOpen(false)
    } catch (error) {
      console.error(`Erro ao ${actionText.toLowerCase()} categoria:`, error)
      snackbar.open({
        message: `Erro ao ${actionText.toLowerCase()} categoria`,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <BaseConfirmationDialog
        open={open}
        setOpen={setOpen}
        title={`${actionText} Categoria`}
        text={`Tem certeza que deseja ${actionText.toLowerCase()} a categoria "${
          category?.name
        }"?`}
        actionButtonText={actionText}
        actionButton={handleConfirmAction}
        variant={isActive ? 'warning' : 'blueConfirmation'}
        disableButton={loading}
      />
    </>
  )
}

ChangeStatusCategoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  category: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default ChangeStatusCategoryDialog
